export const AlertKeysEnum = {
  INCOMING_LAUNCH_DATE: "INCOMING_LAUNCH_DATE",
  EXPIRED_LAUNCH_DATE: "EXPIRED_LAUNCH_DATE",
} as const

export type AlertKey = (typeof AlertKeysEnum)[keyof typeof AlertKeysEnum]
